import React from 'react';
import { Layout } from '../../layout';
import { VideoPoster } from '../../video-posters';

interface VideoPosterPageProps {
  post: any;
}

export default function VideoPosterPage({ post }: VideoPosterPageProps) {
  return (
    <Layout>
      <VideoPoster post={post} />
    </Layout>
  );
}
